import React, { Fragment, useState, useRef } from 'react';
import {
  Grid,
  FormControl,
  MenuItem,
  TextField,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles'
import StrappingTable from '../../../TlmPage/TlmTank/Components/StrappingTable';
import HorizontalTankImg from '../../../TlmPage/TlmTank/Components/Assets/HorizontalTank_ti40042.png'
import ObroundTankImg from '../../../TlmPage/TlmTank/Components/Assets/ObroundTank_ti40043.png';
import VerticalTankImg from '../../../TlmPage/TlmTank/Components/Assets/VerticalTank_ti40781.png';
import { calculateMaxCapacity } from '../../../helpers/calculateMaxCapacity';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  grow: {
    flexGrow: 1,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 300,

    marginBottom: 10
  },
  formControlTags: {
    margin: theme.spacing(1),
    minWidth: 600,

    marginBottom: 10
  },
  infoControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    marginBottom: 0
  },
  cols: {
    paddingRight: 15
  },
  clickButtons: {
    marginLeft: theme.spacing(2),
  },
  inputButton: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    marginTop: 10
  },
  tankInfo: {
    justify: "flex-start",
    alignItems: "center",
  },
  tankInfoForm: {
    minWidth: 400,
  },
  TankImg: {
    height: '300px',
  },
}));

const TankTemplateForm = ({ template = {}, setTemplateData = () => { }, setCalculatedMaxCapacity = () => { }, viewMode = false }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const tankShape = [
    { key: 'vertical', label: t("verticalCylinderRect") },
    { key: 'horizontal', label: t("horizontalCynlinder") },
    { key: 'obround', label: t("obround") },
    { key: 'table', label: t("strappingTable") },
    { key: 'pulseHUB', label: t("existingPulseProTank") }
  ];
  const dimensionunits = [{ key: 'inches', label: t("inches") },
  { key: 'feet', label: t("feet") },
  { key: 'centimeters', label: t("centimeters") }];
  const volumeunits = [{ key: 'liters', label: t("liters") },
  { key: 'gallons', label: t("gallons") }];
  const [dimensionUnit, setDimensionUnits] = useState(template.DimensionUnit || 'inches');
  const [volumeUnit, setVolumeUnits] = useState(template.VolumeUnit || 'gallons');
  const [selectedTankShape, setTankShape] = useState(template.TankShape || 'vertical');
  const [levelVolumeTable, setLevelVolumeTable] = useState(template.VolumeTable || []);
  const [templateName, setTemplateName] = useState(template.name);
  const rtemplateName = useRef("");
  const [tankHeight, setTankHeight] = useState(template.TankHeight || '');
  const rtankHeight = useRef("");
  const [tankDiameter, setTankDiameter] = useState(template.TankDiameter || '');
  const rtankDiameter = useRef("");
  const [tankLength, setTankLength] = useState(template.TankLength || '');
  const rtankLength = useRef("");
  const [tankWidth, setTankWidth] = useState(template.TankWidth || '');
  const rtankWidth = useRef("");
  const [tankCapacity, setTankCapacity] = useState(template.TankCapacity || '');
  const rtankCapacity = useRef("");
  const [fillCapacity, setFillCapacity] = useState(template.FillCapacity || '');
  const rfillCapacity = useRef("");
  const [showTankImage, setShowTankImage] = useState('false');
  const [tankImage, setTankImage] = useState();
  const [csvFileName, setCSVFileName] = useState('reports.csv');
  const [csvReportData, setCSVReportData] = useState([]);
  const csvHeaders = [
    { label: t("fluidHeight"), key: 'height' },
    { label: t("volume"), key: 'volume' },
  ];

  var calculatedMaxCapacity = calculateMaxCapacity(dimensionUnit, volumeUnit, tankHeight, tankWidth, tankDiameter, tankLength, selectedTankShape);

  React.useEffect(() => {
    //Update new Template
    var tTable = levelVolumeTable;

    if (tTable & (tTable !== undefined || tTable.length !== 0)) {
      if (tTable[0].height !== 0 || tTable[0].volume !== 0) {
        tTable.unshift({ height: 0, volume: 0 });
      }
    }

    var lTemplateData = {
      "Name": templateName,
      "Type": "Tank",
      "Params": [
        {
          "DimensionUnit": dimensionUnit,
          "TankDiameter": tankDiameter,
          "TankLength": tankLength,
          "TankShape": selectedTankShape,
          "TankHeight": tankHeight,
          "TankWidth": tankWidth,
          "VolumeUnit": volumeUnit,
          "TankCapacity": tankCapacity,
          "FillCapacity": fillCapacity,
        }
      ],
      "StrappingTable": tTable,
    };
    setTemplateData(lTemplateData);
    setCalculatedMaxCapacity(calculatedMaxCapacity);
  }, [templateName, dimensionUnit, volumeUnit, selectedTankShape, levelVolumeTable, tankHeight, tankLength, tankWidth, tankDiameter, fillCapacity, tankCapacity]);
  
  React.useEffect(() => {
    switch (selectedTankShape) {
      case "vertical":
        setTankImage(VerticalTankImg);
        setShowTankImage(true);
        break;
      case "horizontal":
        setTankImage(HorizontalTankImg);
        setShowTankImage(true);
        break;
      case "obround":
        setTankImage(ObroundTankImg);
        setShowTankImage(true);
        break;
      default:
        setShowTankImage(false);
        setTankImage(undefined);
    }
  }, [selectedTankShape]);

  const handleTableChange = (pair) => {
    if (levelVolumeTable.length < 100) {
      var data = levelVolumeTable;
      data.push({ height: parseInt(pair[0]), volume: parseInt(pair[1]) });
      data = data.sort((a, b) => a.height > b.height ? 1 : b.height > a.height ? -1 : 0);

      setLevelVolumeTable(data);
    }
    else {
      alert(t("strappingTableMustNotExceed"));
    }
  };
  function replaceTable(newTable) {
    var data = newTable;
    data = data.sort((a, b) => a.height > b.height ? 1 : b.height > a.height ? -1 : 0);

    setLevelVolumeTable(data);
  };
  const handleTableRowDelete = (table) => {
    setLevelVolumeTable(() => {
      return [
        ...table
      ]
    });
  };

  React.useEffect(() => {
    createCSVData(levelVolumeTable);
  }, [levelVolumeTable]);

  function createCSVFileName(fileNamePrefix) {
    let d = new Date;
    let dformat = `${("0" + d.getDate()).slice(-2)}${("0" + (d.getMonth() + 1)).slice(-2)}${d.getFullYear()}_${d.getHours()}-${d.getMinutes()}-${d.getSeconds()}`;

    setCSVFileName(fileNamePrefix + '_StrappingTable_' + dformat + '.csv');
  };

  function createCSVData(data_in) {
    var i;
    var k;
    var csvData = [];
    var tempRow = [];

    createCSVFileName(templateName);

    for (i = 0; i < csvHeaders.length; i++) {
      tempRow.push(csvHeaders[i].label);
    }

    csvData.push(tempRow);

    if (data_in.length > 0) {
      for (k = 0; k < data_in.length; k++) {
        tempRow = []
        for (i = 0; i < csvHeaders.length; i++) {
          if (data_in[k][csvHeaders[i].key] === null || data_in[k][csvHeaders[i].key] === undefined) {
            tempRow.push("");
          } else {
            tempRow.push(data_in[k][csvHeaders[i].key]);
          }
        }

        csvData.push(tempRow);
      }
    }

    setCSVReportData(csvData);
  };

  return (
    <Fragment>
      <Grid container direction="row" className={classes.tankInfo}>
        <Grid item xs>
          <Grid container direction="column" justify="flex-start" className={classes.tankInfoForm}>
            <Grid item xs>
              <FormControl className={classes.formControl}>
                <TextField label={t("templateName")} disabled={viewMode}
                  inputRef={rtemplateName}
                  value={templateName}
                  onChange={(e) => {
                    const regex = /^([ a-zA-Z0-9\-]){0,40}$/i;
                    if (regex.test(e.target.value)) {
                      setTemplateName(e.target.value);
                    }
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs>
              <FormControl className={classes.formControl} >
                <TextField select disabled={viewMode}
                  label={t("tankShape")}
                  value={selectedTankShape}
                  onChange={e => setTankShape(e.target.value)}>
                  {tankShape.map(shape => <MenuItem key={shape.key} value={shape.key}>
                    {shape.label}
                  </MenuItem>)}
                </TextField>
              </FormControl>
            </Grid>

            <Grid item xs>
              {<FormControl className={classes.formControl} >
                <TextField select disabled={viewMode}
                  label={t("dimensionsUnits")}
                  value={dimensionUnit}
                  onChange={e => setDimensionUnits(e.target.value)}>
                  {dimensionunits.map(item => (<MenuItem key={item.key} value={item.key}>{item.label}</MenuItem>))}
                </TextField>
              </FormControl>}
            </Grid>

            {(selectedTankShape === 'vertical' || selectedTankShape === 'obround') && <Grid item xs>
              <FormControl className={classes.formControl}>
                <TextField type="number" label={t("height")} disabled={viewMode}
                  inputRef={rtankHeight}
                  value={tankHeight}
                  onChange={e => setTankHeight(e.target.value)}
                  helperText={dimensionUnit} />
              </FormControl>
            </Grid>
            }

            {(selectedTankShape === 'horizontal') && <Grid item xs>
              <FormControl className={classes.formControl}>
                <TextField type="number" label={t("diameter")} disabled={viewMode}
                  inputRef={rtankDiameter}
                  value={tankDiameter}
                  onChange={e => setTankDiameter(e.target.value)}
                  helperText={dimensionUnit} />
              </FormControl>
            </Grid>
            }

            {(selectedTankShape === 'horizontal' || selectedTankShape === 'obround') && <Grid item xs>
              <FormControl className={classes.formControl}>
                <TextField type="number" label={t("length")} disabled={viewMode}
                  inputRef={rtankLength}
                  value={tankLength}
                  onChange={e => setTankLength(e.target.value)}
                  helperText={dimensionUnit} />
              </FormControl>
            </Grid>
            }

            {selectedTankShape === 'obround' && <Grid item xs>
              <FormControl className={classes.formControl}>
                <TextField type="number" label={t("width")} disabled={viewMode}
                  inputRef={rtankWidth}
                  value={tankWidth}
                  onChange={e => setTankWidth(e.target.value)}
                  helperText={dimensionUnit} />
              </FormControl>
            </Grid>
            }

            {<Grid item xs>
              <FormControl className={classes.formControl} >
                <TextField select disabled={viewMode}
                  label={t("volumeUnits")}
                  value={volumeUnit}
                  onChange={e => setVolumeUnits(e.target.value)}>
                  {volumeunits.map(item => (<MenuItem key={item.key} value={item.key}>{item.label}</MenuItem>))}
                </TextField>
              </FormControl>
            </Grid>}

            {selectedTankShape === 'vertical' && <Grid item xs>
              <FormControl className={classes.formControl}>
                <TextField type="number" label={t("maxCapacity")} disabled={viewMode}
                  inputRef={rtankCapacity}
                  value={tankCapacity}
                  onChange={e => setTankCapacity(e.target.value)}
                  helperText={volumeUnit} />
              </FormControl>
            </Grid>
            }

            {(selectedTankShape === 'horizontal' || selectedTankShape === 'obround') && <Grid item xs>
              <FormControl className={classes.formControl}>
                <p>{t("maximumCapacity") + ': '}{calculatedMaxCapacity} {volumeUnit === 'gallons' ? t("gal") : t("l")}</p>
              </FormControl>
            </Grid>
            }

            {(selectedTankShape !== 'pulseHUB') && <Grid item xs>
              <FormControl className={classes.formControl}>
                <TextField type="number" label={t("fillCapacity")} disabled={viewMode}
                  inputRef={rfillCapacity}
                  value={fillCapacity}
                  onChange={e => setFillCapacity(e.target.value)}
                  helperText={volumeUnit === 'gallons' ? t("gallons_caps") : t("liters_caps")} />
              </FormControl>
            </Grid>
            }
          </Grid>
        </Grid>
        <Grid item xs>
          {showTankImage && tankImage !== undefined && <img edge='start'
            alt='tankIamge'
            className={classes.TankImg}
            src={tankImage} />}
          {showTankImage && selectedTankShape === "vertical" && <Typography>{t("verticalCylinderOrRectangular")}</Typography>}
          {showTankImage && <Typography>{t("fillCapacityDefines")}</Typography>}
        </Grid>
        <Grid className={classes.grow}></Grid>
        <Grid className={classes.grow}></Grid>
      </Grid>

      {(selectedTankShape === 'table') && <Grid item xs>
        <StrappingTable tankName={templateName} table={levelVolumeTable} change={handleTableChange} remove={handleTableRowDelete}
          csvFileName={csvFileName} csvReportData={csvReportData} csvHeaders={csvHeaders} replaceTable={replaceTable} viewMode={viewMode} />
      </Grid>
      }
    </Fragment>
  );
};

export default TankTemplateForm;